export default {
  manage_createEditInput_EditTitle: "Editar Etiqueta de Entrada",
  manage_createEditInput_CreateTitle: "Crear nueva Etiqueta de Entrada",
  manage_createEditInput_success: "Etiqueta de Entrada fue creada exitosamente",
  manage_createEditInput_success_edit: "Etiqueta de Entrada fue actualizada exitosamente",
  manage_createEditInput_duplicatedInputErrorMessage: "Esta Etiqueta de Entrada ya existe",
  manage_createEditInput_TitleInputLabel: "Etiqueta de Entrada",
  manage_createEditInput_onLabelInputLabel: "Etiqueta ON",
  manage_createEditInput_offLabelInputLabel: "Etiqueta OFF",
  manage_createEditInput_warning_characters: "La etiqueta de entrada no puede contener emojis",
  manage_createEditInput_warning_characters_onLabel: "La etiqueta ON no puede contener emojis",
  manage_createEditInput_warning_characters_offLabel: "La etiqueta OFF no puede contener emojis",
};
